<template>
  <div>
    <div class="row innerPage">
      <div class="col-sm-6">
        <strong>CPF: </strong>{{ responsavelTeste.cpf }} <br />
        <strong>Nome: </strong>{{ responsavelTeste.nome }}
      </div>
      <div class="col-sm-6 text-right" v-if="visualizaResposta">
        <button
          type="button"
          class="btn shadow-sm mr-2 btn-primary"
          @click="visualizaResposta = false"
        >
          <font-awesome-icon icon="chevron-left" />
          Fechar
        </button>
      </div>
    </div>
    <hr />
    <template v-if="!visualizaResposta">
      <fccTable
        striped
        hover
        :fields="fieldsPedido"
        :orderby="sortBy"
        :actions="actionsPedido"
        :optionsButton="optionsButton"
        :items="listagemPedidosPorResponsavel"
        responsive
        :porPage="itemPorPage"
        pdf
        :titlePage="'Testes realizados ' + responsavelTeste.nome"
        :titlePDF="'Testes realizados ' + responsavelTeste.nome"
      >
      </fccTable>
    </template>
    <template v-else>
      <fcc-view-form
        :apenas-resposta="true"
        :id-candidato="pedidoSelecionado.idrespondente"
        :id-registro-resposta="pedidoSelecionado.idregistroresposta"
        :id-formulario="pedidoSelecionado.idformulario"
        :candidato="dadosCandidato"
        :spi="controleTestes.spi"
        :id-publicacao="idPublicacaoTestes"
        :header-token="dadosLoginSession.fccTokenHeaders"
      />
    </template>
  </div>
</template>

<script>
import store from '../../../store'
import axios from 'axios'
import fccViewForm from 'pkgfe.fccviewform'

export default {
  components: { fccViewForm },
  props: {
    responsavelTeste: {
      type: Object,
      required: true,
      default: () => {}
    },
    idPublicacaoTestes: {
      type: Number,
      required: true,
      default: 0
    },
    controleTestes: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data() {
    return {
      visualizaResposta: false,
      pedidoSelecionado: {},
      membrosComissao: [],
      fieldsPedido: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          label: '',
          funcaoButton: 'atribuirSelecionado',
          value: 'pedido',
          active: true
        },
        { key: 'pedido', label: 'Pedido', sortable: true, active: true },
        {
          key: 'status_',
          label: 'Status',
          sortable: false,
          active: true
        },
        { key: 'actions', label: '', active: true }
      ],
      actionsPedido: [
        {
          button: true,
          funcaoButton: 'listarFormularioPedido',
          icon: 'eye',
          tooltip: 'Visualizar teste',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionsButton: [
        {
          funcaoButton: 'deletandoPedidos',
          tooltip: 'Excluir selecionados',
          icon: 'trash',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      sortBy: 'ordem',
      titlePage: '',
      titleModal: '',
      dadosCandidato: {},
      listagemPedidosPorResponsavel: [],
      titlePDF: 'Testes realizados',
      itemPorPage: '100'
    }
  },
  methods: {
    atribuirSelecionado(_, itens) {
      if (itens.selected && itens.item.status_ !== 'Excluido') {
        this.membrosComissao.push(itens.item.pedido)
      } else {
        this.membrosComissao = this.membrosComissao.filter(
          (membrocomissao) => membrocomissao !== itens.item.pedido
        )
      }
    },
    deletandoPedidos() {
      if (this.membrosComissao.length) {
        this.callConfirm(this.mensagemExcluir, 'os selecionados').then((result) => {
          if (result.value) {
            this.carregaTexto(this.codeMensagem('C03'))
            axios
              .delete(
                store.state.baseUrlGestaoForm + 'CadastroResposta/ExcluirTestePorNumeroRecibo',
                {
                  data: this.membrosComissao,
                  headers: this.dadosLoginSession.fccTokenHeaders.headers
                }
              )
              .then(() => {
                this.listaPedidosTestes(this.responsavelTeste.idresponsavelteste)
                this.carregaTexto()
              })
              .catch(this.setErrorSystem)
          }
        })
      } else {
        this.callAlert('Favor selecione ao menos um item ativo', '', 'error', 'error')
      }
    },
    listarFormularioPedido(_, item) {
      this.carregaTexto(this.codeMensagem('C01'))
      this.pedidoSelecionado = {}
      setTimeout(() => {
        this.pedidoSelecionado = { ...item }
        axios
          .get(
            store.state.baseUrlPublicacao +
              'InscricoesDeferidasCanceladas/ListarCandidatoId/' +
              item.idrespondente,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then((response) => {
            this.dadosCandidato = response.data
            this.visualizaResposta = true
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto)
      }, 1000)
    },
    listaPedidosTestes() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlPublicacao +
            'PublicacaoResponsaveisTeste/ListaPedidoPorCpf/' +
            this.responsavelTeste.cpf +
            '/' +
            this.idPublicacaoTestes,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemPedidosPorResponsavel = []
          if (response.data) {
            response.data.listapedido.map((e) => {
              this.listagemPedidosPorResponsavel.push({
                ...e,
                status_: e.status
              })
            })
          }
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  },
  mounted() {
    this.listaPedidosTestes(this.responsavelTeste.idresponsavelteste)
  }
}
</script>
